import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { Content } from "../../../../getContent/Content";
import { EStatus } from "../../../../../../constants";
import { poll } from "../../../../../../utils/fn";
import { recursiveMerge } from "../../../../../../utils/recursiveMerge";
import { isLowerCaseEquals } from "../../../../../../utils/strings";
import { SBER_ENDPOINTS } from '.';
export var fetchSberPaymentStatus = function fetchSberPaymentStatus(id) {
  return axiosBeelineRequest({
    url: SBER_ENDPOINTS.sberStatus,
    params: {
      id: id
    }
  });
};
export var pollSberpayStatus = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
    var _settings$sberpay;
    var _Content$getInstance$, settings, _recursiveMerge, interval, timeout, getIsProcess, _yield$poll, data, _status, status;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _Content$getInstance$ = Content.getInstance().getData(), settings = _Content$getInstance$.requestSettings;
          _recursiveMerge = recursiveMerge(settings.default, (_settings$sberpay = settings.sberpay) !== null && _settings$sberpay !== void 0 ? _settings$sberpay : {}), interval = _recursiveMerge.interval, timeout = _recursiveMerge.timeout;
          getIsProcess = function getIsProcess(status) {
            return !!(status !== null && status !== void 0 && status.toLowerCase().includes('process'));
          };
          _context.next = 5;
          return poll(function () {
            return fetchSberPaymentStatus(id);
          }, function (res) {
            var _res$status, _res$data;
            return getIsProcess((_res$status = res.status) !== null && _res$status !== void 0 ? _res$status : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.status);
          }, interval, timeout);
        case 5:
          _yield$poll = _context.sent;
          data = _yield$poll.data;
          _status = _yield$poll.status;
          status = _status !== null && _status !== void 0 ? _status : data === null || data === void 0 ? void 0 : data.status;
          if (!(!status || isLowerCaseEquals(status, 'error'))) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", EStatus.Error);
        case 11:
          if (!getIsProcess(status)) {
            _context.next = 13;
            break;
          }
          return _context.abrupt("return", EStatus.Processing);
        case 13:
          return _context.abrupt("return", EStatus.Success);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function pollSberpayStatus(_x) {
    return _ref.apply(this, arguments);
  };
}();